import { createRoot } from 'react-dom/client';
import { IconList } from '@nazka/nazka.mapframe.components';

import './legend.styl';

function Legend({ 
  forPrint, isAggregator, useJobApplicationLocation, homeAddress,
}) {
  return (
    <div className="legend">
      <IconList 
        className="legend__icon-list"
        items={!forPrint ? [
          { key: 0, content: 'Mijn adres', iconProps: { icon: '/img/markers/home-for-legend.png', size: '25px' } },
          { key: 1, content: 'Bedrijf', iconProps: { icon: '/img/markers/work.png', size: '25px' } },
          { key: 2, content: 'Jobkantoor', iconProps: { icon: '/img/markers/intrim.png', size: '25px' } },
          { key: 3, content: 'Adres onzeker', iconProps: { icon: '/img/markers/work-no-address.png', size: '25px' } },
          { key: 4, content: 'Aantal vacatures', iconProps: { icon: '/img/markers/counter.png', size: '25px' } },
        ] : [
          ...(homeAddress ? [{ key: 0, content: 'Mijn adres', iconProps: { icon: '/img/markers/home-for-legend.png', size: '25px' } }] : []),
          ...(!useJobApplicationLocation && !isAggregator ? [{ key: 1, content: 'Bedrijf', iconProps: { icon: '/img/markers/work.png', size: '25px' } }] : []),
          ...(!useJobApplicationLocation && isAggregator ? [{ key: 2, content: 'Jobkantoor', iconProps: { icon: '/img/markers/intrim.png', size: '25px' } }] : []),
          ...(useJobApplicationLocation ? [{ key: 3, content: 'Sollicitatieadres', iconProps: { icon: '/img/markers/sollicitation.png', size: '25px' } }] : []),
          { key: 4, content: 'Station', iconProps: { icon: '/img/markers/train-station.png', size: { height: '15px', width: '25px' } } },
          { key: 5, content: 'Bushalte', iconProps: { icon: '/img/markers/bus-stop.png', size: { height: '14px', width: '25px' } } },
          { key: 6, content: 'Fietssnelweg', iconProps: { icon: '/img/markers/fietssnelweg-example.png', size: { height: '15px', width: '25px' } } },

        ]}
      />
    </div>
  );
}

class LegendControl {
  constructor(forPrint, isAggregator, useJobApplicationLocation, homeAddress) {
    this.forPrint = forPrint;
    this.homeAddress = homeAddress;
    this.isAggregator = isAggregator;
    this.useJobApplicationLocation = useJobApplicationLocation;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl legend-control';
    this._root = createRoot(this._container);
    this._root.render(
      <Legend 
        forPrint={this.forPrint}
        homeAddress={this.homeAddress}
        isAggregator={this.isAggregator}
        useJobApplicationLocation={this.useJobApplicationLocation}
      />,
    );
    return this._container;
  }

  onRemove() {
    this._container?.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default LegendControl;
